import { takeLatest, put, select } from 'redux-saga/effects'

import { createReducer, makeAction, makeKeys } from './helper'
import { httpPost, httpGet, httpDelete, httpPut } from '../core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'
import {
  getHrmsMembers,
  getAllMembers
} from './member'
import {
  fetchGoas
} from './goa'
import {
  getPurchasingGroups,
  getCompanies,
} from './options'
import { 
  purchaseOrderUpdatePath,
  purchaseOrderUpdateDetailPath,
  purchaseOrderUpdateEditPath,
  purchaseOrderEditPath,
  contractEditPath,
  homePath
} from 'routes'
import r from 'reactotron-react-js'

const INITIALIZE_POUPDATE = 'INITIALIZE_POUPDATE'
const CLEAR_POUPDATEDATA = 'CLEAR_POUPDATEDATA'
const FETCH_POUPDATE = makeKeys('FETCH_POUPDATE')
const CHECK_POUPDATE_INPROCESS = makeKeys('CHECK_POUPDATE_INPROCESS')
const CREATE_POUPDATE = 'CREATE_POUPDATE'
const DELETE_POUPDATE = 'DELETE_POUPDATE'
const UPDATE_POUPDATE = 'UPDATE_POUPDATE'
const SUBMIT_POUPDATE = 'SUBMIT_POUPDATE'
const RESUBMIT_POUPDATE = 'RESUBMIT_POUPDATE'
const ACTION_POUPDATE = 'ACTION_POUPDATE'
const SAVE_POUPDATE_ATTACHMENT = 'SAVE_POUPDATE_ATTACHMENT'
const GET_POUPDATE_DETAIL = makeKeys('GET_POUPDATE_DETAIL')
const FETCH_PO_COMPLETE = makeKeys('FETCH_PO_COMPLETE')
const GET_PO_COMPLETE_DETAIL = makeKeys('GET_PO_COMPLETE_DETAIL')
const CLEAR_PO_COMPLETE_DETAIL = 'CLEAR_PO_COMPLETE_DETAIL'
const GET_POU_GOA_WORK_FLOW_VIEW_MODE = makeKeys('GET_POU_GOA_WORK_FLOW_VIEW_MODE')
const GET_POU_GOA_WORK_FLOW_EDIT_MODE = makeKeys('GET_POU_GOA_WORK_FLOW_EDIT_MODE')
const GET_POU_REQUESTTYPES = makeKeys('GET_POU_REQUESTTYPES')
const PRE_REJECT = 'PRE_REJECT'
const PRE_PURCHASE_SUBMIT = 'PRE_PURCHASE_SUBMIT'
const PURCHASE_SUBMIT = 'PURCHASE_SUBMIT'
const SET_ACCEPT_CONFIRM = 'SET_ACCEPT_CONFIRM'
const CLOSE_ACCEPT_CONFIRM = 'CLOSE_ACCEPT_CONFIRM'
const SET_REJECT_CONFIRM = 'SET_REJECT_CONFIRM'
const CLOSE_REJECT_CONFIRM = 'CLOSE_REJECT_CONFIRM'
const SET_PURCHASESUBMIT_CONFIRM = 'SET_PURCHASESUBMIT_CONFIRM'
const CLOSE_PURCHASESUBMIT_CONFIRM = 'CLOSE_PURCHASESUBMIT_CONFIRM'
const SET_CREATORSUBMIT_CONFIRM = 'SET_CREATORSUBMIT_CONFIRM'
const CLOSE_CREATORSUBMIT_CONFIRM = 'CLOSE_CREATORSUBMIT_CONFIRM'

export const initializePOUpdate = makeAction(INITIALIZE_POUPDATE, 'isDetail')
export const clearPOUpdateData = makeAction(CLEAR_POUPDATEDATA)
export const fetchPOUpdateList = makeAction(FETCH_POUPDATE.REQUEST, 'dataSearch')
export const checkPOUpdateInprocess = makeAction(CHECK_POUPDATE_INPROCESS.REQUEST, 'pouId','poSapDocNumber')
export const createPOUpdate = makeAction(CREATE_POUPDATE, 'data', 'history', 'isSubmit')
export const updatePOUpdate = makeAction(UPDATE_POUPDATE, 'data', 'history', 'isSubmit')
export const deletePOUpdate = makeAction(DELETE_POUPDATE, 'id', 'history')
export const submitPOUpdate = makeAction(SUBMIT_POUPDATE, 'data', 'history')
export const reSubmitPOUpdate = makeAction(RESUBMIT_POUPDATE, 'data', 'history')
export const actionPOUpdate = makeAction(ACTION_POUPDATE, 'data', 'history')
export const getPOUpdateDetail = makeAction(GET_POUPDATE_DETAIL.REQUEST, 'pouId', 'history', 'isEdit', 'mode')
export const savePOUpdateAttachment = makeAction(SAVE_POUPDATE_ATTACHMENT, 'data', 'history', 'isSubmit')
export const fetchPOComplete = makeAction(FETCH_PO_COMPLETE.REQUEST, 'showLoading','poSapNumber', 'mode')
export const getPOCompleteDetail = makeAction(GET_PO_COMPLETE_DETAIL.REQUEST, 'poSapNumber', 'mode')
export const clearPOCompleteDetail = makeAction(CLEAR_PO_COMPLETE_DETAIL)
export const getPOUGOAWorkFlowViewMode = makeAction(GET_POU_GOA_WORK_FLOW_VIEW_MODE.REQUEST, 'pouId')
export const getPOUGOAWorkFlowEditMode = makeAction(GET_POU_GOA_WORK_FLOW_EDIT_MODE.REQUEST, 'data')
export const getPOURequestTypes = makeAction(GET_POU_REQUESTTYPES.REQUEST)
export const postPreReject = makeAction(PRE_REJECT, 'data', 'submit', 'history')
export const postPrePurchaseSubmit = makeAction(PRE_PURCHASE_SUBMIT, 'data', 'submit', 'history')
export const postPurchaseSubmit = makeAction(PURCHASE_SUBMIT, 'data', 'history')
export const setAcceptConfirm = makeAction(SET_ACCEPT_CONFIRM, 'message')
export const closeAcceptConfirm = makeAction(CLOSE_ACCEPT_CONFIRM)
export const setRejecttConfirm = makeAction(SET_REJECT_CONFIRM, 'message')
export const closeRejecttConfirm = makeAction(CLOSE_REJECT_CONFIRM)
export const setPurchaseSubmitConfirm = makeAction(SET_PURCHASESUBMIT_CONFIRM, 'message')
export const closePurchaseSubmitConfirm = makeAction(CLOSE_PURCHASESUBMIT_CONFIRM)
export const setCreatorSubmitConfirm = makeAction(SET_CREATORSUBMIT_CONFIRM, 'id', 'message')
export const closeCreatorSubmitConfirm = makeAction(CLOSE_CREATORSUBMIT_CONFIRM)

const fetchPOUpdateListSuccess = makeAction(FETCH_POUPDATE.SUCCESS, 'data')
const checkPOUpdateInprocessSuccess = makeAction(CHECK_POUPDATE_INPROCESS.SUCCESS, 'data')
const getPOUpdateDetailSuccess = makeAction(GET_POUPDATE_DETAIL.SUCCESS, 'data')
const fetchPOCompleteSuccess = makeAction(FETCH_PO_COMPLETE.SUCCESS, 'data')
const getPOCompleteDetailSuccess = makeAction(GET_PO_COMPLETE_DETAIL.SUCCESS, 'data')
const getPOUGOAWorkFlowViewModeSuccess = makeAction(GET_POU_GOA_WORK_FLOW_VIEW_MODE.SUCCESS, 'data')
const getPOUGOAWorkFlowEditModeSuccess = makeAction(GET_POU_GOA_WORK_FLOW_EDIT_MODE.SUCCESS, 'data')
const getPOURequestTypesSuccess = makeAction(GET_POU_REQUESTTYPES.SUCCESS, 'data')

const multipartHeader = { 'Content-Type': 'multipart/form-data', }

const initial = {
  pouList: {},
  checkPOUpdate: {data:{}, loading:false},
  pouDetail: { data:{}, loading:true },
  poComplete: { data:[], loading:false },
  poCompleteDetail: { data:{}, loading:false },
  goaWorkFlow:{ data: [], loading: false },
  pouRequestTypes:{ data: [], loading: false },
  acceptConfirm:{ show:false, message:''},
  rejectConfirm:{ show:false, message:''},
  purchaseSubmitConfirm:{ show:false, message:''},
  creatorSubmitConfirm:{ show:false, id:0, message:''}
}

function* initializePOUpdateRequest(action) {
  const {isDetail} = action.payload 
  try {
    const state = yield select()
    if (!state.goa.goas.length) {
      yield put(fetchGoas())
    }
    // yield put(getHrmsMembers(isDetail))
    yield put(getAllMembers(isDetail))
    if(!state.options.companies.data.length){
      yield put(getCompanies())
    }
    if(!state.options.purchasingGroups.data.length){
      yield put(getPurchasingGroups())
    }
  } catch (e) {
    console.log('eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
    console.log(e)
  }
}

function* fetchPOUpdateListRequest( action ) {
  const { dataSearch } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet('purchaseOrderUpdate',dataSearch)
    if (response.status >= 200 && response.status < 300) {
      yield put(fetchPOUpdateListSuccess(response.data))
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(fetchPOUpdateList(dataSearch))
    } else {
      yield put(fetchPOUpdateListSuccess({}))
    }
  }
}

function* checkPOUpdateInprocessRequest( action ) {
  const { pouId,poSapDocNumber } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(`purchaseOrderUpdate/checkInprocess/${pouId}/${poSapDocNumber}`)
    if (response.status >= 200 && response.status < 300) {
      yield put(checkPOUpdateInprocessSuccess(response.data))
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(checkPOUpdateInprocessSuccess({}))
  }
}

function* createPOUpdateRequest( action ) {
  const { data, history, isSubmit } = action.payload
  try {
    yield put(appLoading('Save Request PO Update'))
    const response = yield httpPost('purchaseOrderUpdate',data)
    if (response.status >= 200 && response.status < 300) {
      if(response.data.message == undefined){
        yield put(savePOUpdateAttachment({...data, id:response.data}, history, isSubmit))
      }else{
        yield put(appLoaded())
        yield put(toastError(response.data.message))
      }
    }
  } catch (e) {
    if(e.data){
      yield put(toastError(e.data.message))
    }else{
      yield put(toastError('Save Request PO Update fail'))
    }
    yield put(appLoaded())
  }
}

function* deletePOUpdateRequest( action ) {
  const { id, history } = action.payload
  try {
    yield put(appLoading('Delete Request PO Update'))
    const response = yield httpDelete(`purchaseOrderUpdate/${id}`)
    if (response.status >= 200 && response.status < 300) {
      yield put(appLoaded())
      history.push(purchaseOrderUpdatePath)
    }
  } catch (e) {
    if(e.data){
      yield put(toastError(e.data.message))
    }else{
      yield put(toastError('Delete Request PO Update fail'))
    }
    yield put(appLoaded())
  }
}

function* updatePOUpdateRequest( action ) {
  const { data, history, isSubmit } = action.payload
  try {
    yield put(appLoading('Update Request PO Update'))
    const response = yield httpPut(`purchaseOrderUpdate/${data.id}`,data)
    if (response.status >= 200 && response.status < 300) {
      yield put(savePOUpdateAttachment(data, history, isSubmit))
    }
  } catch (e) {
    if(e.data){
      yield put(toastError(e.data.message))
    }else{
      yield put(toastError('Update Request PO Update fail'))
    }
    yield put(appLoaded())
  }
}

function* savePOUpdateAttachmentRequest( action ) {
  const { data, history, isSubmit } = action.payload
  try {
    yield put(appLoading('Upload attachments'))
    var attachmentsData = {}
    if (data.ch02) attachmentsData.ch02 = data.ch02
    if(Object.keys(attachmentsData).length){
      const response = yield httpPost(`purchaseOrderUpdate/${data.id}/Attachments`,attachmentsData, multipartHeader)
      if (response.status >= 200 && response.status < 300) {
        if(isSubmit){
          if(data.status==5){
            yield put(reSubmitPOUpdate(data, history))
          }else{
            const responseCheck = yield httpPost(`purchaseOrderUpdate/${data.id}/preCreatorSubmit`)
            if (responseCheck.status >= 200 && responseCheck.status < 300) {
              if(responseCheck.data.success){
                yield put(submitPOUpdate({id:data.id}, history))
              }else{
                yield put(appLoaded())
                yield put(setCreatorSubmitConfirm(data.id,responseCheck.data.message))
              }
            }
          }
        }else{
          history.push(purchaseOrderUpdatePath)
          yield put(toastSuccess('Save Request PO Update success'))
        }
      }
    }else{
      if(isSubmit){
        if(data.status==5){
          yield put(reSubmitPOUpdate(data, history))
        }else{
          const responseCheck = yield httpPost(`purchaseOrderUpdate/${data.id}/preCreatorSubmit`)
          if (responseCheck.status >= 200 && responseCheck.status < 300) {
            if(responseCheck.data.success){
              yield put(submitPOUpdate({id:data.id}, history))
            }else{
              yield put(appLoaded())
              yield put(setCreatorSubmitConfirm(data.id,responseCheck.data.message))
            }
          }
        }
      }else{
        history.push(purchaseOrderUpdatePath)
        yield put(toastSuccess('Save Request PO Update success'))
      }
    }
  } catch (e) {
    if(e.data){
      yield put(toastError(e.data.message))
    }else{
      yield put(toastError('Upload attachments fail'))
    }
    yield put(appLoaded())
  }
}

function* submitPOUpdateRequest( action ) {
  const { data, history } = action.payload
  try {
    yield put(closeCreatorSubmitConfirm())
    yield put(appLoading('Submit Request PO Update'))
    const response = yield httpPost(`purchaseOrderUpdate/${data.id}/submit`)
    if (response.status >= 200 && response.status < 300) {
      history.push(purchaseOrderUpdatePath)
      yield put(toastSuccess('Submit Request PO Update success'))
    }
    yield put(appLoaded())
  } catch (e) {
    if(e.data){
      yield put(toastError(e.data.message))
    }else{
      yield put(toastError('Submit Request PO Update fail'))
    }
    yield put(appLoaded())
  }
}

function* reSubmitPOUpdateRequest( action ) {
  const { data, history } = action.payload
  try {
    yield put(appLoading('Submit Request PO Update'))
    const response = yield httpPost(`purchaseOrderUpdate/reSubmit`,{docId:data.id,sn:data.sn,comment:data.actionComment})
    if (response.status >= 200 && response.status < 300) {
      history.push(purchaseOrderUpdatePath)
      yield put(toastSuccess('Submit Request PO Update success'))
    }
    yield put(appLoaded())
  } catch (e) {
    if(e.data){
      yield put(toastError(e.data.message))
    }else{
      yield put(toastError('Submit Request PO Update fail'))
    }
    yield put(appLoaded())
  }
}

function* actionPOUpdateRequest( action ) {
  const { data, history } = action.payload
  try {
    yield put(appLoading('Action PO Update'))
    const response = yield httpPost(`purchaseOrderUpdate/${data.docId}/actionApproval`, data, multipartHeader)
    if (response.status >= 200 && response.status < 300) {
      if(history.location.search.includes('h=true')){
        history.push(homePath)
      }else{
        history.push(purchaseOrderUpdatePath)
      }
      yield put(toastSuccess('Action PO Update success'))
    }
    yield put(appLoaded())
  } catch (e) {
    if(e.data){
      yield put(toastError(e.data.message))
    }else{
      yield put(toastError('Action PO Update fail'))
    }
    yield put(appLoaded())
  }
}

function* getPOUpdateDetailRequest( action ) {
  const { pouId, history, isEdit, mode } = action.payload
  try {
    yield put(appLoading())
    let username = localStorage.getItem('username').toLowerCase()
    const response = yield httpGet(`purchaseOrderUpdate/${pouId}`)
    if (response.status >= 200 && response.status < 300) {
      let data = response.data
      if(isEdit){
        if(data.status==0||data.status==5){
          if(data.createdByUser==username||data.requesterUser==username){
            yield put(getPOUpdateDetailSuccess(data))
            yield put(appLoaded())
            if(data.status==5){
              yield put(fetchPOComplete(true,data.purchaseOrderNumber, mode))
            }else{
              yield put(fetchPOComplete(true, null,mode))
            }
          }else{
            yield put(appLoaded())
            history.replace(purchaseOrderUpdateDetailPath(data.id))
          }
        }else{
          yield put(appLoaded())
          history.replace(purchaseOrderUpdateDetailPath(data.id))
        }
      }else{
        if(data.status==0||data.status==5){
          if(data.createdByUser==username||data.requesterUser==username){
            yield put(appLoaded())
            history.replace(purchaseOrderUpdateEditPath(data.id))
          }else{
            yield put(getPOUpdateDetailSuccess(data))
            yield put(appLoaded())
            yield put(fetchPOComplete(true,data.purchaseOrderNumber,mode))
          }
        }else{
          yield put(getPOUpdateDetailSuccess(data))
          yield put(appLoaded())
          yield put(fetchPOComplete(true,data.purchaseOrderNumber,mode))
        }
      }
    }
    
  } catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getPOUpdateDetail(pouId, history, isEdit, mode))
    } else {
      if(e.data){
        yield put(toastError(e.data.message))
      }else{
        yield put(toastError('Can not connect to server.'))
      }
    }
  }
}

function* fetchPOCompleteRequest(action) {
  const { showLoading, poSapNumber, mode } = action.payload
  try {
    if(showLoading) yield put(appLoading())
    const response = yield httpGet('purchaseOrders/getPOComplete',{mode:mode, poSapNum:poSapNumber})
    if (response.status >= 200 && response.status < 300) {
      yield put(fetchPOCompleteSuccess(response.data))
    }
    if(showLoading) yield put(appLoaded())
  } catch (e) {
    yield put(fetchPOCompleteSuccess([]))
    if(showLoading) yield put(appLoaded())
  }
}

function* getPOCompleteDetailRequest(action) {
  const { poSapNumber, mode } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet('purchaseOrders/getPOCompleteDetail',{mode:mode, poSapNum:poSapNumber})
    if (response.status >= 200 && response.status < 300) {
      yield put(getPOCompleteDetailSuccess(response.data))
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(getPOCompleteDetailSuccess({}))
  }
}

function* getPOUGOAWorkFlowViewModeRequest(action) {
  const { pouId } = action.payload
  try {
    const response = yield httpGet('purchaseOrderUpdate/workflowApproverViewMode',{id:pouId})
    if (response.status >= 200 && response.status < 300) {
      yield put(getPOUGOAWorkFlowViewModeSuccess(response.data))
    }
  } catch (e) {
    yield put(getPOUGOAWorkFlowViewModeSuccess([]))
  }
}

function* getPOUGOAWorkFlowEditModeRequest(action) {
  const { data } = action.payload
  try {
    const response = yield httpGet('purchaseOrderUpdate/workflowApproverEditMode',data)
    if (response.status >= 200 && response.status < 300) {
      yield put(getPOUGOAWorkFlowEditModeSuccess(response.data))
    }
  } catch (e) {
    yield put(getPOUGOAWorkFlowEditModeSuccess([]))
  }
}

function* getPOURequestTypesRequest() {
  try {
    const response = yield httpGet('purchaseOrderUpdate/requestTypes')
    if (response.status >= 200 && response.status < 300) {
      yield put(getPOURequestTypesSuccess(response.data))
    }
  } catch (e) {
    yield put(getPOURequestTypesSuccess([]))
  }
}

function* postPreRejectRequest(action) {
  const { data, submit, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(`purchaseOrderUpdate/${data.docId}/preReject?submit=${submit}`)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      const result = response.data
      if(result.success){
        yield put(actionPOUpdate(data, history))
      }else{
        yield put(toastError(result.message))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError(e.data.message))
  }
}

function* postPrePurchaseSubmitRequest(action) {
  const { data, submit, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(`purchaseOrderUpdate/${data.docId}/preSubmit?submit=${submit}`)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      const result = response.data
      if(result.success){
        yield put(postPurchaseSubmit(data, history))
      }else{
        if(result.confirm){
          yield put(setAcceptConfirm(result.message))
        }else{
          yield put(toastError(result.message))
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError(e.data.message))
  }
}

function* postPurchaseSubmitRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(`purchaseOrderUpdate/${data.docId}/purchaseSubmit`, data, multipartHeader)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      const result = response.data
      if(result.success){
        if(result.purchaseOrderId){
          yield put(toastSuccess('Accept PO update success. Please fill-in PO new version and submit to approval.'))
          if(result.contractId){
            window.open(contractEditPath(result.contractId))
          }
          history.replace(purchaseOrderEditPath(result.purchaseOrderId))
          window.scrollTo(0,0)
        }else if(result.contractId){
          yield put(toastSuccess('Accept PO update success. Please fill-in contract and submit to approval.'))
          history.replace(contractEditPath(result.contractId))
          window.scrollTo(0,0)
        }else{
          yield put(toastSuccess('Accept PO update success.'))
          history.replace(purchaseOrderUpdatePath)
          window.scrollTo(0,0)
        }
      }else{
        if(result.requestConfirmDp){
          yield put(setPurchaseSubmitConfirm(result.requestConfirmDpMessage))
        }else{
          yield put(toastError(result.message))
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError(e.data.message))
  }
}

export function* watchPOUpdateSaga() {
  yield takeLatest(INITIALIZE_POUPDATE, initializePOUpdateRequest)
  yield takeLatest(FETCH_POUPDATE.REQUEST, fetchPOUpdateListRequest)
  yield takeLatest(CHECK_POUPDATE_INPROCESS.REQUEST, checkPOUpdateInprocessRequest)
  yield takeLatest(CREATE_POUPDATE, createPOUpdateRequest)
  yield takeLatest(DELETE_POUPDATE, deletePOUpdateRequest)
  yield takeLatest(UPDATE_POUPDATE, updatePOUpdateRequest)
  yield takeLatest(SUBMIT_POUPDATE, submitPOUpdateRequest)
  yield takeLatest(RESUBMIT_POUPDATE, reSubmitPOUpdateRequest)
  yield takeLatest(ACTION_POUPDATE, actionPOUpdateRequest)
  yield takeLatest(SAVE_POUPDATE_ATTACHMENT, savePOUpdateAttachmentRequest)
  yield takeLatest(GET_POUPDATE_DETAIL.REQUEST, getPOUpdateDetailRequest)
  yield takeLatest(FETCH_PO_COMPLETE.REQUEST, fetchPOCompleteRequest)
  yield takeLatest(GET_PO_COMPLETE_DETAIL.REQUEST, getPOCompleteDetailRequest)
  yield takeLatest(GET_POU_GOA_WORK_FLOW_VIEW_MODE.REQUEST, getPOUGOAWorkFlowViewModeRequest)
  yield takeLatest(GET_POU_GOA_WORK_FLOW_EDIT_MODE.REQUEST, getPOUGOAWorkFlowEditModeRequest)
  yield takeLatest(GET_POU_REQUESTTYPES.REQUEST, getPOURequestTypesRequest)
  yield takeLatest(PRE_REJECT, postPreRejectRequest)
  yield takeLatest(PRE_PURCHASE_SUBMIT, postPrePurchaseSubmitRequest)
  yield takeLatest(PURCHASE_SUBMIT, postPurchaseSubmitRequest)
}

export default createReducer(initial, state => ({
  [CLEAR_POUPDATEDATA]: () => ({
    ...state,
    checkPOUpdate: {data:{}, loading:false},
    pouDetail: { data:{}, loading:true },
    poComplete: { data:[], loading:false },
    poCompleteDetail: { data:{}, loading:false },
    goaWorkFlow:{ data: [], loading: false },
  }),
  [FETCH_POUPDATE.REQUEST]: () => ({
    ...state,
  }),
  [FETCH_POUPDATE.SUCCESS]: (data) => ({
    ...state,
    pouList: data.data,
  }),
  [CHECK_POUPDATE_INPROCESS.REQUEST]: () => ({
    ...state,
    checkPOUpdate: { data:{}, loading:true}
  }),
  [CHECK_POUPDATE_INPROCESS.SUCCESS]: (data) => ({
    ...state,
    checkPOUpdate: { data:data.data, loading:false}
  }),
  [GET_POUPDATE_DETAIL.REQUEST]: () => ({
    ...state,
    pouDetail:{ data:{}, loading:true}
  }),
  [GET_POUPDATE_DETAIL.SUCCESS]: (data) => ({
    ...state,
    pouDetail:{ data:data.data, loading:true}
  }),
  [FETCH_PO_COMPLETE.REQUEST]: () => ({
    ...state,
    poComplete:{ data:[], loading:true }
  }),
  [FETCH_PO_COMPLETE.SUCCESS]: (data) => ({
    ...state,
    poComplete:{ data:data.data, loading:false }
  }),
  [GET_PO_COMPLETE_DETAIL.REQUEST]: () => ({
    ...state,
    poCompleteDetail:{ data:{}, loading:true }
  }),
  [GET_PO_COMPLETE_DETAIL.SUCCESS]: (data) => ({
    ...state,
    poCompleteDetail:{ data:data.data, loading:false }
  }),
  [CLEAR_PO_COMPLETE_DETAIL]: () => ({
    ...state,
    poCompleteDetail:{ data:{}, loading:false }
  }),
  [GET_POU_GOA_WORK_FLOW_VIEW_MODE.REQUEST]: () => ({
    ...state,
    goaWorkFlow:{ data:[], loading:true }
  }),
  [GET_POU_GOA_WORK_FLOW_VIEW_MODE.SUCCESS]: (data) => ({
    ...state,
    goaWorkFlow:{ data:data.data, loading:false }
  }),
  [GET_POU_GOA_WORK_FLOW_EDIT_MODE.REQUEST]: () => ({
    ...state,
    goaWorkFlow:{ data:[], loading:true }
  }),
  [GET_POU_GOA_WORK_FLOW_EDIT_MODE.SUCCESS]: (data) => ({
    ...state,
    goaWorkFlow:{ data:data.data, loading:false }
  }),
  [GET_POU_REQUESTTYPES.REQUEST]: () => ({
    ...state,
    pouRequestTypes:{ data:[], loading:true }
  }),
  [GET_POU_REQUESTTYPES.SUCCESS]: (data) => ({
    ...state,
    pouRequestTypes:{ data:data.data, loading:false }
  }),
  [SET_ACCEPT_CONFIRM]: (data) => ({
    ...state,
    acceptConfirm:{ show:true, message:data.message},
  }),
  [CLOSE_ACCEPT_CONFIRM]: () => ({
    ...state,
    acceptConfirm:{ show:false, message:''},
  }),
  [SET_REJECT_CONFIRM]: (data) => ({
    ...state,
    rejectConfirm:{ show:true, message:data.message}
  }),
  [CLOSE_REJECT_CONFIRM]: () => ({
    ...state,
    rejectConfirm:{ show:false, message:''}
  }),
  [SET_PURCHASESUBMIT_CONFIRM]: (data) => ({
    ...state,
    purchaseSubmitConfirm:{ show:true, message:data.message}
  }),
  [CLOSE_PURCHASESUBMIT_CONFIRM]: () => ({
    ...state,
    purchaseSubmitConfirm:{ show:false, message:''}
  }),
  [SET_CREATORSUBMIT_CONFIRM]: (data) => ({
    ...state,
    creatorSubmitConfirm:{ show:true, id:data.id, message:data.message}
  }),
  [CLOSE_CREATORSUBMIT_CONFIRM]: () => ({
    ...state,
    creatorSubmitConfirm:{ show:false, id:0, message:''}
  }),
}))